function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// TODO: add types!
import { __assign } from "tslib";
/*
works with objects and arrays
*/

export function shallowCopy(val) {
  if (_typeof(val) === 'object') {
    if (Array.isArray(val)) {
      val = Array.prototype.slice.call(val);
    } else if (val) {
      // non-null
      val = __assign({}, val);
    }
  }

  return val;
}
export function mapHash(input, func) {
  var output = {};

  for (var key in input) {
    if (input.hasOwnProperty(key)) {
      output[key] = func(input[key], key);
    }
  }

  return output;
}